// @flow

import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

import SignupButton from '../components/shared/SignupButton'
import OutlineButton from '../components/shared/OutlineButton'
import Button from '../components/shared/Button'

import MarginContainer from '../components/shared/MarginContainer'
import { mixpanelTrack } from '../utils/mixpanel'

import SignalHeroMobile1 from "./_images/signal_mobile_hero1.svg"
import SignalHeroMobile2 from "./_images/signal_mobile_hero2.svg"
import SignalArrowMobile from "./_images/signal_arrow.svg"

import Highlight2 from "./_images/highlight_2.png"
import Highlight3 from "./_images/highlight_3.png"


import * as colors from '../theme/colors';

const Container = styled.div`
  min-height: 100vh;
  overflow: hidden;
`

const Wrapper = styled.div`
  flex: 1;
  display: grid;
  height: 90vh;
  grid-template-columns: 380px auto 480px;
  grid-template-rows: 25% auto 100px;
  position: relative;

  
  grid-template-areas:
    "header header header"
    "left gutter right"
    "footer footer footer";

  .highlight-2 {
    position: absolute;
    width: 150px;
    top: 2%;
    right: 0;

    @media (max-width: 767px) {
      top: 1%;
      right: -49px;
    }
  }
  .highlight-3 {
    position: absolute;
    width: 150px;
    bottom: 2%;
    left: 0;

    @media (max-width: 767px) {
      bottom: -5%;
      left: -50px;
    }
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    height: auto;
    padding-bottom: 100px;
  }
`


const Left = styled.div`
  grid-area: left;
  a {
    color: #F4CDC9;
  }

  @media (max-width: 767px) {
    margin-top: 40%;
    position: relative;
    z-index: 10;
  }
`

const Right = styled.div`
  grid-area: right;
  
  p {
    line-height: 1.5;
    margin-bottom: 40px;
    
  }
`

const Links = styled.div`
  flex: 1;
  font-size: 16px;
  text-transform: uppercase;
  font-family: faktumExtraBold;
  text-align: center;
  a {
    display: block;
    margin-bottom: 16px;
  }
  span {
    color: #F5C02B;
  }
`

const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  grid-area: footer;
  font-family: faktumRegular;
  font-size: 18px;

  a {
    color: #F5C02B;
  }

  @media (max-width: 767px) {
    padding: 50px 0;
    text-align: center;
    line-height: 1.5;
  }
`

class IndexPage extends Component {

  state = {
    isVideoOpen: false
  }
  
  componentDidMount() {
    mixpanelTrack("marketing.home.visit");
  }

  render() {

      const hostArray = typeof window !== 'undefined' && window.location.host.split(".");
      let subdomain = "";
      // If we don't have a 3 parts domain then you're probably on localhost.
      if (hostArray.length === 3) {
        subdomain = hostArray[0];
      }
    
      return (
      <Container>
        <MarginContainer style={{height:"100%"}}>
          <Wrapper>
            <img src={Highlight2} className="highlight-2" alt="" />
            <img src={Highlight3} className="highlight-3" alt="" />
            <Left>
              <h2>
                Squadlytics is moving to <a href="https://tability.io">Tability.io</a>
              </h2>
            </Left>
            <Right>
              <p>
                We've renamed Squadlytics to Tability to represent our purpose better.
                We want to make it easier for every team to focus on their goals, and deliver their vision.
                This means keeping tabs on what's important, and enabling you to do your best work.
              </p>
              <p>
              If you're an existing customer, all your data has been kept and you can
              access your workspace at tability.io.
              </p>
              <Links>
                <a href="https://tability.io">Continue to tability.io <span>></span></a>
                {subdomain && (
                  <a href={`https://${subdomain}.tability.io`}>Continue to {`${subdomain}.tability.io`}<span>></span></a>
                )}
              </Links>
            </Right>
            <Footer>
              <p>Have any question? Contact us at <a href="mailto:support@tability.io">support@tability.io</a></p>
            </Footer>
          </Wrapper>
        </MarginContainer>
      </Container>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js